// Offline Storage Manager for Canon Data

const STORAGE_KEY = 'canon-compass-offline';
const VERSION_KEY = 'canon-compass-version';

export const offlineStorage = {
  // Save canon data to localStorage
  saveCanon: (data) => {
    try {
      const storageData = {
        ...data,
        savedAt: new Date().toISOString(),
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(storageData));
      localStorage.setItem(VERSION_KEY, data.version || '1.0.0');
      return true;
    } catch (error) {
      console.error('Failed to save canon offline:', error);
      return false;
    }
  },

  // Load canon data from localStorage
  loadCanon: () => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      if (data) {
        return JSON.parse(data);
      }
      return null;
    } catch (error) {
      console.error('Failed to load offline canon:', error);
      return null;
    }
  },

  // Check if offline data exists
  hasOfflineData: () => {
    return localStorage.getItem(STORAGE_KEY) !== null;
  },

  // Get saved version
  getVersion: () => {
    return localStorage.getItem(VERSION_KEY);
  },

  // Get saved timestamp
  getSavedAt: () => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      if (data) {
        const parsed = JSON.parse(data);
        return parsed.savedAt;
      }
      return null;
    } catch {
      return null;
    }
  },

  // Clear offline data
  clearCanon: () => {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(VERSION_KEY);
  },

  // Get storage size in MB
  getStorageSize: () => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      if (data) {
        const bytes = new Blob([data]).size;
        return (bytes / 1024 / 1024).toFixed(2);
      }
      return 0;
    } catch {
      return 0;
    }
  },

  // Export as downloadable JSON file
  exportAsFile: (data) => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `canon-compass-v${data.version || '1.0.0'}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  },
};

export default offlineStorage;
